module.exports = __webpack_public_path__ + "img/alipay-collection-code.4f657d5a.png";